import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@mui/material";

import NavBar from "../../components/Navbar";
import { getHRByFiscalYear, getFiscalYears } from "../../store/ducks/duckHr";
import LoadingComponent from "../../components/LoadingComponent";
import ControlComponent from "../../components/ControlComponent";

import Table from "./components/Table";

const HrComponent = () => {
  const { data, isLoading, fiscalYears } = useSelector((state) => state.hr);
  const dispatch = useDispatch();
  const [fiscalYear, setFiscalYear] = useState("2025-2026");

  useEffect(() => {
    dispatch(getFiscalYears());
    dispatch(getHRByFiscalYear(fiscalYear));
  }, [dispatch, fiscalYear]);

  if (fiscalYears.lenght == 0) {
    return <LoadingComponent loading={isLoading} />;
  }

  return (
    <>
      {!fiscalYears.length > 0 ? (
        <LoadingComponent loading={!fiscalYears.lenght > 0} />
      ) : (
        <>
          <Grid>
            <NavBar
              isHr
              withLocation
              fiscalYear={fiscalYear}
              fiscalYears={fiscalYears}
              setFiscalYear={setFiscalYear}
            />
            <Grid
              container
              item
              direction="column"
              justify="flex-start"
              spacing={0}
              style={{
                minHeight: "calc(100% - 64px)",
                paddingLeft: "10vw",
                paddingTop: 88,
                maxWidth: "100vw",
              }}
              xs={12}
            >
              <Grid style={{ paddingRight: "10vw", height: 320 }}>
                <Table data={data} fiscalYear={fiscalYear} />
              </Grid>
              <Grid>
                <ControlComponent />
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default HrComponent;
